// @ts-nocheck


import React from 'react';
import styled from 'styled-components';
import { navigate } from '../../lib/routerAdapter';
import notification from 'antd/lib/notification';


import { Crumb } from '../../components/layout/Breadcrumbs';
import Breadcrumbs from '../../components/layout/Breadcrumbs';
import { Header, Panel } from '../../components/layout';
import InnerForm from './components/InnerForm';
import { goBack } from './../../lib/helpers';
import { notificationLoading } from './../../components/Notifications';
import { stockPartApi } from '../../lib/api';

const StyledPanel = styled(Panel).withConfig({ displayName: "StockPartForm__StyledPanel", componentId: "sc-5ayk2g-0" })(["padding-top:0;"]);











export class StockPartForm extends React.Component {
  state = {
    stockPart: null
  };

  async componentDidMount() {
    const { stockPartId } = this.props;
    try {
      if (stockPartId) {
        const stockPart = await stockPartApi.getStockPart(stockPartId);
        this.setState({ stockPart });
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  }

  handleSubmit = async (values) => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      if (values.id) {
        await stockPartApi.updateStockPart(values);
      } else {
        await stockPartApi.addStockPart(values);
      }
      navigate(`/admin/stock-part`);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  handleCancel = () => goBack('/admin/stock-part');

  render() {
    const { stockPart } = this.state;
    return (
      <>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/admin/stock-part">
                Перечень материалов для проведения работ хоз.способом
              </Crumb>
              {stockPart ?
            <Crumb>Деталь №{stockPart.id}</Crumb> :

            <Crumb>Новая деталь</Crumb>
            }
            </Breadcrumbs>
          } />

        <StyledPanel>
          <h1>{stockPart ? `Деталь №${stockPart.id}` : 'Новая деталь'}</h1>
        </StyledPanel>
        <InnerForm
          stockPart={stockPart}
          onSubmit={this.handleSubmit}
          onCancel={this.handleCancel} />

      </>);

  }
}

export default StockPartForm;
